import { render, staticRenderFns } from "./select-type-answer.vue?vue&type=template&id=1c68bdd9&"
import script from "./select-type-answer.vue?vue&type=script&lang=js&"
export * from "./select-type-answer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports